import { render, staticRenderFns } from "./payBill.vue?vue&type=template&id=15001f52&scoped=true&"
import script from "./payBill.vue?vue&type=script&lang=js&"
export * from "./payBill.vue?vue&type=script&lang=js&"
import style0 from "./payBill.vue?vue&type=style&index=0&id=15001f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15001f52",
  null
  
)

export default component.exports